'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.userActions = exports.scrapperActions = exports.outfeatActions = exports.instagramActions = exports.navigationActions = exports.discoverActions = exports.authActions = undefined;

var _helper = require('./utils/helper');

var authActions = exports.authActions = {
	LOGIN: (0, _helper.createAction)('LOGIN'),
	FETCH_USER: (0, _helper.createAction)('FETCH_USER')
};

var discoverActions = exports.discoverActions = {
	FETCH_POPULAR: (0, _helper.createAction)('FETCH_POPULAR')
};

var navigationActions = exports.navigationActions = {
	SET_FROM_PAGE: 'SET_FROM_PAGE'
};

var instagramActions = exports.instagramActions = {
	LOAD_INSTAGRAM_POSTS: (0, _helper.createAction)('LOAD_INSTAGRAM_POSTS')
};

var outfeatActions = exports.outfeatActions = {
	FIND_OUTFEAT: (0, _helper.createAction)('FIND_OUTFEAT'),
	CREATE_OUTFEAT: (0, _helper.createAction)('CREATE_OUTFEAT'),
	UPDATE_OUTFEAT: (0, _helper.createAction)('UPDATE_OUTFEAT')
};

var scrapperActions = exports.scrapperActions = {
	SCRAPE: (0, _helper.createAction)('SCRAPE')
};

var userActions = exports.userActions = {
	LOAD_USER_OUTFEATS: (0, _helper.createAction)('LOAD_USER_OUTFEATS')
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/actionTypes.js
 ** module id = 78
 ** module chunks = 0
 **/